export default "__VITE_ASSET__DtiHhFN___"